<template>
  <div class="flex flex-row lg:flex-col justify-between lg:justify-start space-y-2  items-center ">
    <div id="banner" class="bg-white border" :style="{
      '--percentage': pxPercente + 'px'
    }"
    >
      <div class="stroke-1 stroke-current absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-black z-50 text-center">{{ percetagemLabel }}%</div>
      <div class="fill">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="500px" height="300px" viewBox="0 0 500 300" enable-background="new 0 0 500 300" xml:space="preserve">
          <path id="waveShape" :fill="cor" d="M300,300V2.5c0,0-0.6-0.1-1.1-0.1c0,0-25.5-2.3-40.5-2.4c-15,0-40.6,2.4-40.6,2.4
	c-12.3,1.1-30.3,1.8-31.9,1.9c-2-0.1-19.7-0.8-32-1.9c0,0-25.8-2.3-40.8-2.4c-15,0-40.8,2.4-40.8,2.4c-12.3,1.1-30.4,1.8-32,1.9
	c-2-0.1-20-0.8-32.2-1.9c0,0-3.1-0.3-8.1-0.7V300H300z"
          />
        </svg>
      </div>
    </div>
    <div class="flex flex-col space-y-2 text-center">
      <span class="font-semibold text-xs">#{{ tank }} {{ nome }}</span>
      <span class="font-semibold text-xs">Capacidade: {{ capacidadeLabel }} L</span>
      <span class="font-semibold text-xs">Saldo: {{ saldoLabel }} L</span>
    </div>
  </div>
</template>

<script>
import { format } from '@/Utils/money.js'
import { getHexColor } from '@/Utils/colors.js'
export default {
  props: {
    tanque:Object,
  },
  computed:{
    tank(){
      return this.tanque.idTanque
    },
    capacidade(){
      return this.tanque.capacidade
    },
    nome(){
      return this.tanque.nome
    },
    capacidadeLabel(){
      return format(this.capacidade, 3)
    },
    saldo(){
      return this.tanque.VolumeAproximado
    },
    saldoLabel(){
      return format(this.tanque.VolumeAproximado, 3)
    },
    cor(){
      return this.getHexColor(this.tanque.corCombustivel)
    },
    percetagem(){
      return this.saldo /this.capacidade
    },
    percetagemLabel(){
      return format((this.percetagem *100).toFixed(2), 2)
    },
    un(){
      return this.tanque.un
    },
    pxPercente(){
      const sizeTank = 120 //120px;
      if(this.percetagem >= 1){
        return -5
      }
      return sizeTank - (this.percetagem.toFixed(2) * sizeTank)
    },

  },
  methods: {
    getHexColor,
  },
}
</script>

<style>
#banner {
    border-radius: 50%;
    width: 120px;
    height: 120px;
    overflow: hidden;
    backface-visibility: hidden;
    transform: translate3d(0, 0, 0);
    position: relative;
}
#banner .fill {
    animation-name: fillAction;
    animation-iteration-count: 1;
    animation-timing-function: cubic-bezier(.2, .6, .8, .4);
    animation-duration: 4s;
    animation-fill-mode: forwards;
}
#banner #waveShape {
    animation-name: waveAction;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-direction:alternate;
    animation-duration: 3s;
    width:120px;
    height: 120px;
}
@keyframes fillAction {
    0% {
        transform: translate(0, 120px);
    }
    100% {
        transform: translate(0, var(--percentage));
    }
}
@keyframes waveAction {
    0% {
        transform: translate(-120px, 0);
    }
    100% {
        transform: translate(0, 0);
    }
}
</style>
